// extracted by mini-css-extract-plugin
export default {"image":"FilePreview_image__aRZ-5"};